import React, { useState } from "react";
import "./Carousel.css";

export const CarouselItem = ({ children, width}) => {

    return(children)
    /*return(
        <div className="carousel-item-circular" style={{ width: width}}>
            {children}
        </div>
    )*/
};

const Carousel = ({children}) => {
    const [activeIndex, setActiveIndex] = useState( window.innerWidth <= 800 ? 0 : 1);
    const [mobile, setMobile] = useState( window.innerWidth <= 800 );

    const updateIndex = (newIndex) => {
        if(newIndex < 0) {
            newIndex = 0;
        } else if (newIndex >= React.Children.count(children)){
            newIndex = React.Children.count(children) -1;
        }

        setActiveIndex(newIndex);
    }

    return (
        <div className="carousel">
            
            {!mobile && <button className="btn btn_prev" onClick={() => {
                updateIndex(activeIndex -1);
            }}>
                Prev
            </button>}

            <div className="inner" style={{ transform: `translateX(${mobile ? activeIndex * -100 :(activeIndex == 0 ? activeIndex + 33 : activeIndex == 1 ? 0 : -33)}%)`}}>
                {React.Children.map(children, (child, index) => {
                    var cx = require('classnames');
                    return <div className={mobile ? "carousel-item-circular-movil active" : index === activeIndex ? "carousel-item-circular active" : "carousel-item-circular"} style={{width: `${mobile ? "100%": "33%"}`}} > 
                    {React.cloneElement(child, 
                        {
                            key: index, 
                            width: mobile ? "100%": "33%", 
                            className: cx(child.props.className, "active")
                        })
                    }
                    </div>;
                })}
            </div>
            
            {!mobile && <button className="btn btn_next" onClick={() => {
                updateIndex(activeIndex +1);
            }}>
                Next
            </button>}

            {!mobile && <div className="indicators">

                {React.Children.map(children, (child, index) => {
                    return(
                        <button
                        className={`${index === activeIndex ? "btn btn_circle active" : "btn btn_circle"}`}
                        onClick={() => {
                            updateIndex(index);
                        }}
                        >
                            {index + 1}
                        </button>
                    );
                })}
            </div>}
        </div>
    )
}

export default Carousel;
